import React, { useContext } from 'react';

import { Channels } from './../../utils/static';
import { AppContext } from '../../app';
import { Button, Form, Select } from 'antd';

const CondIsUserReachable = (props) => {
  const [form] = Form.useForm();
  const { journey, syncCache } = useContext(AppContext);

  const onFinish = (e) => {
    let currentStep = journey.steps.find(
      (step) => step.id + '' === props.node.id + ''
    );
    currentStep['channel'] = e.channel;
    delete currentStep.ui?.error;
    syncCache('update-step', currentStep, true);
    // openSnackBar("success", {
    //   message: "Successfully updated",
    // });
    props.closeModal();
  };

  const selectedNode = journey?.steps?.filter(
    (item) => item.id + '' === props?.node?.id
  );
  const selectedValue = selectedNode.length && selectedNode[0]?.channel;

  const onEventChange = () => {};

  return (
    <>
      <Form form={form} onFinish={onFinish} className="modal_wrap">
        <div className={'modal-body'}>
          <Form.Item
            label="Check if user is reachable on"
            name="channel"
            rules={[{ required: true, message: 'Please add a channel!' }]}
            initialValue={selectedValue}
          >
            <Select
              style={{ width: 300 }}
              placeholder="Select a channel"
              onChange={onEventChange}
              disabled={props.readOnly}
            >
              {Channels.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
            {/* <IconFilter className={"icon-sm"} /> */}
          </Form.Item>
        </div>
        <div className={'modal-footer'}>
          <Form.Item>
            <Button
              shape="round"
              type="primary"
              htmlType="submit"
              disabled={props.readOnly}
            >
              Save State
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
export default CondIsUserReachable;
